export class DoUiActionClientHandlerResult {
    public submit?: boolean;
    public reload?: boolean;
    public static default: DoUiActionClientHandlerResult = { submit: true, reload: true, performValidation: true };
    public static stop: DoUiActionClientHandlerResult = { submit: false, reload: false, performValidation: false};
    public performValidation: boolean = true;
}